export const QUESTION_MULTIPLECHOICE_TOGGLE_ANSWER_IS_SELECTED =
  'QUESTION_MULTIPLECHOICE_TOGGLE_ANSWER_IS_SELECTED';

export const QUESTION_MULTIPLECHOICE_SET_SINGLE_ANSWER_SELECTED =
  'QUESTION_MULTIPLECHOICE_SET_SINGLE_ANSWER_SELECTED';

export const SET_SINGLE_ANSWER_SELECTED = 'SET_SINGLE_ANSWER_SELECTED';

export const toggleAnswerIsSelected = (questionId, answerId) => dispatch => {
  dispatch({
    type: QUESTION_MULTIPLECHOICE_TOGGLE_ANSWER_IS_SELECTED,
    payload: { questionId, answerId }
  });
};

export const setSingleAnswerSelected = (questionId, answerId, questionType) => dispatch => {
  switch (questionType) {
    case QUESTION_MULTIPLECHOICE_SET_SINGLE_ANSWER_SELECTED:
      dispatch({
        type: QUESTION_MULTIPLECHOICE_SET_SINGLE_ANSWER_SELECTED,
        payload: { questionId, answerId }
      });
      return;
    case SET_SINGLE_ANSWER_SELECTED:
      dispatch({
        type: SET_SINGLE_ANSWER_SELECTED,
        payload: { questionId, answerId }
      });
      return;
    default:
      dispatch({
        type: QUESTION_MULTIPLECHOICE_SET_SINGLE_ANSWER_SELECTED,
        payload: { questionId, answerId }
      });
  }
};
